export default __webpack_public_path__ + "static/media/microphone.fc33dbeb.svg";